import React from "react";
import { useApiDocsContext } from "../startup/ApiDocsApp";
import SidebarCategory from "./SidebarCategory";
import SearchInput from "./SearchInput";

const Sidebar = () => {
  const { filteredCategories, searchTerm, sidebarOpen, setSelectedEndpointId } = useApiDocsContext();

  return (
    <aside className={`api-docs-sidebar ${sidebarOpen ? "api-docs-sidebar--open" : ""}`}>
      <div className="api-docs-sidebar-header">
        <a href="/developers" className="api-docs-logo">
          <img src="/Opendate-mark-512.png" alt="Opendate" className="api-docs-logo-image" />
          <span className="api-docs-logo-text">Opendate</span>
          <span className="api-docs-logo-badge">API</span>
        </a>
      </div>
      <SearchInput />
      <nav className="api-docs-sidebar-nav">
        <a
          href="/developers"
          className="api-docs-sidebar-intro-link"
          onClick={(e) => {
            e.preventDefault();
            window.history.replaceState(null, "", "/developers");
            setSelectedEndpointId(null);
          }}
        >
          Introduction
        </a>
        {filteredCategories.map((category) => (
          <SidebarCategory key={category.file} category={category} />
        ))}
        {filteredCategories.length === 0 && searchTerm.trim() && (
          <div className="api-docs-no-results">No endpoints found</div>
        )}
      </nav>
    </aside>
  );
};

export default Sidebar;
